module.exports = __webpack_public_path__ + "img/arrow-simple.2f7bcce0.svg";